import * as tslib_1 from "tslib";
import { Component } from '../common/component';
import { ToolHelper } from '../utility/index';
var CommandContainer = /** @class */ (function (_super) {
    tslib_1.__extends(CommandContainer, _super);
    function CommandContainer(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        _this.contents = [];
        var keys = 'contents';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                obj[key].forEach(function (item) {
                    var domObj = ToolHelper.createObjectByType(item.type);
                    if (domObj) {
                        _this.contents.push(new domObj(item));
                    }
                });
            }
        });
        return _this;
    }
    CommandContainer.prototype.toJSON = function () {
        var result = [];
        if (this.contents && this.contents.length) {
            this.contents.forEach(function (item) {
                result.push(item.toJSON());
            });
        }
        return Object.assign({}, _super.prototype.toJSON.call(this), { "contents": result, "type": "CommandContainer" });
    };
    CommandContainer.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return CommandContainer;
}(Component));
export { CommandContainer };
//# sourceMappingURL=command_container.js.map